export const BidAmountDetail = {
  properties: {
    Amount: {
      'bulk-upload-header': 'Bid',
    },
  },
};
